import VueI18n from 'vue-i18n';
import messages from './messages';
import Vue from 'vue';

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: localStorage.getItem('locale') || 'en', // 设置地区
    fallbackLocale: 'en',
    messages, // 设置地区信息
});
export default i18n;
